import { createContext, useState, useContext, useRef } from 'react';
import type { ReactNode, Dispatch, SetStateAction } from 'react';
import { noop } from '@hotjar/webapp/lib/function';

interface ShortLinkWidgetHiddenState {
  isHidden: boolean;
  setIsHidden: Dispatch<SetStateAction<boolean>>;
}

let ShortLinkWidgetHiddenContext = createContext<ShortLinkWidgetHiddenState>({
  isHidden: false,
  setIsHidden: noop,
});

export function ShortLinkWidgetHiddenStateProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const isInitializedRef = useRef(false);

  const [isHidden, setIsHidden] = useState(false);
  // FIXME: This creates a new object on every render and may create unnecessary rerenders.
  //        Fix this or add a comment to explain why it's desired.
  //        More details: https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/jsx-no-constructed-context-values.md
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = { isHidden, setIsHidden };

  if (!isInitializedRef.current) {
    ShortLinkWidgetHiddenContext = createContext<ShortLinkWidgetHiddenState>({
      isHidden,
      setIsHidden,
    });
    isInitializedRef.current = true;
  }

  return (
    <ShortLinkWidgetHiddenContext.Provider value={value}>
      {children}
    </ShortLinkWidgetHiddenContext.Provider>
  );
}

/**
 * Future person: this function has been re-exported by packages/subscription-management,
 * if you extract this out of webapp into a standalone util please inform `@hotjar/monetization-platform` or `@hotjar/billing` FE so they are aware
 */
export function useShortLinkWidgetHiddenState(): ShortLinkWidgetHiddenState {
  return useContext(ShortLinkWidgetHiddenContext);
}
